import type { Environment } from '@azzo/energyx-contracts';

export const environment: Environment = {
    name: 'staging',
    production: true,
    kindeClientId: 'ec00d65af8c54773af41c7190a39869c',
    kindeAudience: 'https://stg.api.azzoenergyx.io',
    kindeAuthDomain: 'https://stg.auth.azzoenergyx.io',
    redirectUrl: 'https://stg.app.azzoenergyx.io',
    backendAPIUrl: 'https://stg.api.azzoenergyx.io/basecamp/v1',
    internalAPIUrl: 'https://stg.api.azzoenergyx.io/v1',
    fcasAPIUrl: 'https://stg.api.azzoenergyx.io/nembidding/v1',
    nemEventsAPIUrl: 'https://stg.api.azzoenergyx.io/nemevents/v1',
    acmsAPIUrl: 'https://stg.api.azzoenergyx.io/acms/v1',
    remotesBaseUrl: 'https://cdn-basecamp-azzo-stg-aue-gnhsdvacc9aydze3.z01.azurefd.net/',
    federationManifest: { kind: 'hosted', path: 'manifests/federation.manifest.json' },
    // Staging is a real deployment but not THE production environment — §7's preview flow is sanctioned
    // here (dev/stg), so overrides stay allowed. See federation-manifest-resolver.ts.
    allowManifestOverrides: true,
    datadog: {
        enabled: true,
        applicationId: '52fcb3b3-c76e-494e-b615-e1535cbcc1d7', // public ID for browser-based monitoring
        clientToken: 'pub92281804da65e0f5ae3613b2a85bb30a', // public token that RUM requires to be accessible in browser
        site: 'us3.datadoghq.com',
        service: 'basecamp-frontend',
        env: 'staging',
        sessionSampleRate: 50,
        sessionReplaySampleRate: 5,
        defaultPrivacyLevel: 'mask-user-input',
    }
};
